import { applyFilters, doRequest } from "./helpers";

export default class MetaLeadService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/leads`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getLead(accountId, leadId) {
    return doRequest("GET", `/meta_ad_account/${accountId}/leads/${leadId}`);
  }

  static async previewImport(accountId, { s3_key, file_name, dataset_id }) {
    return doRequest(
      "POST",
      `/meta_ad_account/${accountId}/leads/import/preview`,
      {
        data: { s3_key, file_name, dataset_id },
      }
    );
  }

  static async import(accountId, { s3_key, file_name, dataset_id }) {
    return doRequest("POST", `/meta_ad_account/${accountId}/leads/import`, {
      data: { s3_key, file_name, dataset_id },
    });
  }
}
